import aboutConfig from './about/aboutConfig';
import articleConfig from './article/articleConfig';
import blogConfig from './blog/blogConfig';
import homeConfig from './home/homeConfig';
import providersConfig from './providers/providersConfig';
import patientsConfig from './patients/patientsConfig';
import pricingConfig from './pricing/pricingConfig';
import featuresConfig from './features/featuresConfig';
import securityConfig from './security/securityConfig';
import directoryConfig from './directory/directoryConfig';

const marketingConfig = [
  aboutConfig,
  articleConfig,
  blogConfig,
  homeConfig,
  providersConfig,
  patientsConfig,
  pricingConfig,
  featuresConfig,
  securityConfig,
  directoryConfig
];

export default marketingConfig;